/* eslint-disable no-underscore-dangle */

import { ChartConfiguration, ChartTooltipItem, ChartData } from 'chart.js';
import { PIE_CHART_MAX_SLICE_COUNT } from '../../utils/constants';
import { wantToOpenInNewTabVanillaEvent } from '../../utils/linkUtils';
import {
  decisionTooltipLabel,
  percentTooltipLabel,
  mergeSlices,
  generateColorRange,
  canClick,
} from './chartsUtils';

type Base = {
  data: Array<number>;
  labels: Array<string>;
  handleClick?: (wantToOpenInNewTab: boolean, index: number | null) => void;
  baseH: number;
  canvasId?: string;
};

export function getDecisionPieChartConfig(args: Base) {
  return getPieChartConfig({
    ...args,
    displayTooltipLabel: decisionTooltipLabel,
  });
}
export function getPercentPieChartConfig(args: Base) {
  return getPieChartConfig({
    ...args,
    displayTooltipLabel: percentTooltipLabel,
  });
}

export function getPieChartConfig(args: {
  data: Array<number>;
  labels: Array<string>;
  handleClick?: (wantToOpenInNewTab: boolean, index: number | null) => void;
  baseH: number;
  displayTooltipLabel: (
    tooltipItem: ChartTooltipItem,
    chart: ChartData,
  ) => string | string[];
}): ChartConfiguration {
  if (args.data != null) {
    const { newData, newLabels } = mergeSlices({
      data: args.data,
      labels: args.labels,
    });
    const colors = generateColorRange({
      baseH: args.baseH,
      minSL: 20,
      maxSL: 80,
      nb: newData.length,
    });
    const hasOther = args.data.length > PIE_CHART_MAX_SLICE_COUNT;
    return {
      type: 'pie',
      data: {
        datasets: [
          {
            data: newData,
            backgroundColor: colors,
          },
        ],
        labels: newLabels.map((l) => ` ${l} `),
      },
      options: {
        maintainAspectRatio: false,
        onClick: (
          event?: MouseEvent,
          activeElements?: Array<{ _index: number }>,
        ) => {
          const index =
            activeElements && activeElements.length > 0
              ? activeElements[0]._index
              : null;
          if (canClick({ index, hasOther }) && args.handleClick) {
            const openInNewTab =
              !!event && wantToOpenInNewTabVanillaEvent(event);
            args.handleClick(openInNewTab, index);
          }
        },
        onHover: (event: MouseEvent, activeElements: { _index: number }[]) => {
          if (document.body && args.handleClick) {
            if (
              activeElements.length &&
              activeElements[0]._index < PIE_CHART_MAX_SLICE_COUNT - 1
            ) {
              document.body.style.cursor = 'pointer';
            } else {
              document.body.style.cursor = 'default';
            }
          }
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: args.displayTooltipLabel,
          },
        },
      },
    };
  }
  return {};
}

/* eslint-enable no-underscore-dangle */
